// Step 1: Import React
//import React, {useEffect} from 'react'
import React from 'react'
import Layout from '../components/layout-bootstrap'
import SongsList from '../components/songs-list'
import Gallery from '../components/video-gallery'
import { StaticImage } from 'gatsby-plugin-image'

import { graphql } from 'gatsby'

import youtubeMusic from "../images/youtube-music.svg"
import spotify from "../images/spotify.svg"

//import instagram from "../images/iconmonstr-instagram-13.svg"
//import facebook from "../images/iconmonstr-facebook-4.svg"
import Instagram from "../images/iconmonstr-instagram-13.inline.svg";
import Facebook from "../images/iconmonstr-facebook-4.inline.svg";
import Soundcloud from "../images/iconmonstr-soundcloud-4.inline.svg";
import Twitter from "../images/iconmonstr-twitter-4.inline.svg";
import Spotify from "../images/spotify-navbar.inline.svg";
import YouTubeMusic from "../images/youtube-music-navbar.inline.svg";


// Importing the Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.module.css'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import '../components/site-navbar.module.css'


import { MediaPlayerControls } from '@cassette/player';
import { PlayerContextProvider, playerContextFilter } from '@cassette/core';

import '@cassette/player/dist/css/cassette-player.css';
import {
  sectionTitle,
  myFooter,
  lastContainer,
  discosDiv,
  musicPlatformIcon,
  footerIcons,
  logo,
  footerLogoText,
  logoFooterContainer,
  spotifyDiskDiv,
  divFooterCol,
  iconSvg,
} from './index.module.css'

// Step 2: Define your component
const IndexPage = ({ data }) => {

  const SongsListWrapped = playerContextFilter(SongsList, [
    'playlist',
    'activeTrackIndex',
    'onSelectTrackIndex'
  ]);
  const playlist = data.allFile.edges.map((node, i) => ({title: node.node.name, url: node.node.publicURL}));

  return (
    <wrapper  id="home" class="d-flex flex-column">
        <PlayerContextProvider playlist={playlist}>
            <Layout pageTitle="Home Page">

                <StaticImage
                  
                  alt=""
                  src="../images/ajiaco_full.jpeg"
                />
                <Container id="canciones">
                  <span className={sectionTitle} ></span>
                  <Container>
                    <Row className="justify-content-md-center">
                      <Col md={6}><StaticImage src="../images/songs.png" alt="A dinosaur" /></Col>
                      <Col md={6}><SongsListWrapped/></Col>
                    </Row>
                  </Container>
                </Container>
              
                <Container id="videos">
                  <span className={sectionTitle} ></span>  
                  <Gallery urls={[
                    "https://www.youtube.com/embed/wd4w0yzdjMw", 
                    "https://www.youtube.com/embed/iPzzjVQrfDQ",
                    "https://www.youtube.com/embed/kgaqX49fSa0",
                    "https://www.youtube.com/embed/tBexYFhGkvI",
                    "https://www.youtube.com/embed/wOBHR-jlZ70",
                    "https://www.youtube.com/embed/UHcKjHb7tTY",
                    ]}>
                  </Gallery>
                </Container>
                  
                <Container className={lastContainer} id="discos">
                  <span className={sectionTitle}></span>
                  <div className={discosDiv}>
                    <h3>Ajiaco (2009) 
                      <a href="https://music.youtube.com/playlist?list=OLAK5uy_mAaJtEEgq1g8YUlhzBMhR0WBI6f4I1p70&feature=share" target="_blank" rel="noreferrer">
                        <img img opacity={0.5} src={youtubeMusic} className={musicPlatformIcon} alt={"Go to Ajiaco 2009 in YouTube Music"}/>
                      </a>
                      <a href="https://open.spotify.com/album/2zSbPHAcPelD10IC11Geuj?si=daGX7afIRtedzpv4MNudLg" target="_blank" rel="noreferrer">
                        <img img opacity={0.5} src={spotify} className={musicPlatformIcon} alt={"Go to Ajiaco 2009 in Spotify"}/>
                      </a>
                    </h3>
                    {/*<p>El inicio de la banda, con Francisco de la Fuente en la voz, Leo Medina y Pato Loncomilla en guitarras, y Diego Roda en la batería</p>  */}
                    {/* https://music.youtube.com/playlist?list=OLAK5uy_mAaJtEEgq1g8YUlhzBMhR0WBI6f4I1p70&feature=share className={icon}*/}
                    <div className={spotifyDiskDiv}>
                      <iframe src="https://open.spotify.com/embed/album/2zSbPHAcPelD10IC11Geuj?utm_source=generator&theme=0" 
                              width="100%" height="80" frameBorder="0" allowfullscreen="" 
                              title="Ajiaco 2009 on Spotify"
                              allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture">
                      </iframe>
                    </div>
                  </div>
                </Container>

                <Container className={logoFooterContainer}>
                  <Row>
                    <Col md={3} ></Col>
                    <Col md={6} className={divFooterCol}> 
                      <StaticImage
                        alt=""
                        src="../images/logo.png"
                        width={200}
                        className={logo}
                      />
                      
                    
                      <div className={footerIcons}>
                        <a href="https://www.instagram.com/bandaajiaco"><Instagram className={iconSvg}/> </a>
                        <a href="https://twitter.com/BandaAjiaco"><Twitter className={iconSvg}/> </a>
                        <a href="https://www.facebook.com/BandaAjiaco/"><Facebook className={iconSvg}/> </a>
                        <a href="https://open.spotify.com/artist/59xb7B3RlWrUxlxfvUdzHo?si=wBZBSeOUSoiFIGieN7asYQ"><Spotify className={iconSvg}/> </a>
                        <a href="https://music.youtube.com/channel/UCoVE4roIDE9nVhftj5Al9JA?feature=share"><YouTubeMusic className={iconSvg}/> </a>
                        <a href="https://soundcloud.com/bandaajiaco"><Soundcloud className={iconSvg}/> </a>
                        
                      </div> 
                      <div className={footerLogoText}>
                        <p>© Santiago, Chile, 2022</p>
                      </div>  
                  
          
                    </Col>
                    <Col md={8}></Col>
                  </Row>
                </Container>

                {/* <Container id="integrantes">
                <h2 className={sectionTitle} >INTEGRANTES</h2>
                </Container> */}
              
              </Layout>
            
            <footer className={myFooter}>
                  <MediaPlayerControls controls={[
                    'spacer',
                    'playpause',
                    'forwardskip',
                    'mute',
                    'spacer',
                    'progress'
                  ]}/>
              </footer>
        </PlayerContextProvider>
    </wrapper>
    
  )
}

export const query = graphql`
    query SongsQuery {
      allFile(filter: { sourceInstanceName: { eq: "songs" } }) {
          edges {
            node {
              name
              publicURL
              extension
              dir
              modifiedTime
            }
          }
        }
    
    }
  `

// Step 3: Export your component
export default IndexPage


// Embed links
// "https://www.youtube.com/embed/wd4w0yzdjMw", 
// "https://www.youtube.com/embed/iPzzjVQrfDQ",
// "https://www.youtube.com/embed/kgaqX49fSa0",
// "https://www.youtube.com/embed/tBexYFhGkvI",
// "https://www.youtube.com/embed/wOBHR-jlZ70",
// "https://www.youtube.com/embed/UHcKjHb7tTY",

// Full links
// "https://www.youtube.com/watch?v=UHcKjHb7tTY", 
// "https://www.youtube.com/watch?v=kgaqX49fSa0"